module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vheader'), _vm._v(" "), _c('vuser')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-e4c945b8"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/User.vue
// module id = 159
// module chunks = 1